<script>
  import { onMount } from 'svelte';

  export let label;
  export let maxHeight = 200;
  import { Popover } from 'bootstrap';
  let readMore = true;
  export let showSticky = false;
  let btnSticky;
  export let onSticky = () => {};
  onMount(() => {
    if (showSticky && btnSticky) {
      new Popover(btnSticky, {
        container: btnSticky.parentElement,
        animation: false,
      });
    }
  });
</script>

<div
  class="w-100"
  style="position: relative;{readMore ? 'max-height:' + maxHeight + 'px;overflow: hidden;' : ''}"
>
  <div class="d-flex flex-row">
    <span class="text-break d-block me-1">{@html label}</span>
  </div>
  <div>
    {#if readMore == true}
      <button
        on:click={() => {
          readMore = false;
        }}
        class="border-0 bg-white p-0"
        style="    width: 100%;text-align:left;position: absolute;top:{maxHeight - 15}px;"
      >
        <span class="text-break d-block me-1 color-blue">Read More...</span>
      </button>
    {/if}
    {#if showSticky}
      <button
        bind:this={btnSticky}
        on:click={() => onSticky()}
        style="position: absolute;right: 0;bottom: 0;"
        data-bs-placement="top"
        data-bs-toggle="popover"
        data-bs-trigger="hover focus"
        data-bs-content="Click to make it un-sticky"
        class="color-blue font-weight-400 border-0 mb-0 bg-white font-weight-400 py-0"
        ><img
          alt=""
          class="icon-14 me-1"
          src="/images/sticky-tag.svg"
        /> Sticky</button
      >
    {/if}
  </div>
</div>
